
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'Success',
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
  created() {
    sessionStorage.setItem('success', 'success');
  },
});
